// In-progress form persistence (FIX 2). The share URL covers submitted results;
// this covers the *unsubmitted* form so it survives a full reload when an in-app
// browser (e.g. WeChat) evicts the page while the user is away.
//
// All access is wrapped in try/catch: some in-app browsers and private modes
// throw on localStorage. Persistence is best-effort — the app works without it.

export const FORM_STORAGE_KEY = 'canwego_form_state'

export function saveFormState(state) {
  try {
    window.localStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(state))
  } catch {
    /* storage blocked — skip persistence, app still works */
  }
}

export function loadFormState() {
  try {
    const raw = window.localStorage.getItem(FORM_STORAGE_KEY)
    if (!raw) return null
    const state = JSON.parse(raw)
    if (typeof state !== 'object' || state === null || !Array.isArray(state.members)) {
      return null
    }
    return state
  } catch {
    return null
  }
}

export function clearFormState() {
  try {
    window.localStorage.removeItem(FORM_STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
